<script lang="ts">
	import Accord from '#components/accord.svelte'
	import type { Blok, Accord as IAccord } from '#library/components.schema.build.ts'

	interface Props {
		blok: Blok<IAccord>
	}

	let { blok }: Props = $props()
	let { title, body, size, active } = $derived(blok)
</script>

<Accord {title} {body} {size} {active} />
